import { defaultI18n, generateDefaultI18nConfig } from '@fs/utils';
import enTranslations from 'src/i18n/en.json';
import faTranslations from 'src/i18n/fa.json';

const config = generateDefaultI18nConfig();

const addTranslationSchema = (locale: 'fa' | 'en', resources: unknown) => {
  defaultI18n.addResourceBundle(locale, 'translation', resources as object, true, true);
};

defaultI18n
  .init(config as object)
  .then(() => {
    addTranslationSchema('en', enTranslations);
    addTranslationSchema('fa', faTranslations);
  })
  .catch((err) => {
    console.error('i18n initialization failed:', err);
  });

export { defaultI18n, addTranslationSchema };
